<style>
    .page-content {
        padding: 24px 28px;
        width: 100%;
    }

    @media (max-width: 768px) {
        .page-content {
            padding: 16px;
        }
    }
</style>

<div class="page-content">
    <slot></slot>
</div>
